import request from '@/utils/request';
import _ from 'lodash';

// 인증번호를 전송하는 함수
export function sendCertificateNumber(name, phoneNumber) {
	// 차후 변경될 Restful 형식에 따라 수정해야 함
	return request({
		url: '/login/auth/phone',
		method: 'post',
		data: phoneNumber,
	});
}

// 가입시 아이디 중복 체크 함수
export function registUserDataChk(userId) {
	return request({
		url: '/login/check/user_id/' + userId,
		method: 'get',
	});
}

// 대쉬보드
export function getUserDashboard(data) {
	return request({
		url: '/v2/main/userDashboard',
		method: 'post',
		data,
	});
}

//휴면해지
export function userPauseUnlock(data) {
	return request({
		url: '/userPauseUnlock ',
		method: 'post',
		data,
	});
}

// 마케팅 미동의 고객 조회
export function getMktPopupYn(data) {
	return request({
		url: '/user/getMktPopupYn',
		method: 'post',
		data,
	});
}

// 마케팅 다음에 받기 날짜 or 수신동의 상태를 저장
export function saveMarketingAgree(data) {
	return request({
		url: '/user/saveMarketingAgree',
		method: 'post',
		data,
	});
}

// 사용자 결제수단 조회
export function getPaymentsBlockInfo(data) {
	return request({
		url: '/user/payments/blocked',
		method: 'get',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}
